import { useEffect, useState } from 'react';

import { servGetTiposRelatorioPorCpf } from '../../servicos/servicosEmRotasPrivadas/tipo_relatorio';

function SelectTipoRelatorio({ setTipoRelatorio }) {

    const [tipoRelatorioList, setTipoRelatorioList] = useState([])

    useEffect(() => {
        getTiposRelatorioPorCpf()
    }, []);

    const getTiposRelatorioPorCpf = async () => {
        try {
            const tipoRelatorioDaApi = await servGetTiposRelatorioPorCpf()
            setTipoRelatorioList(tipoRelatorioDaApi)
        } catch (erro) {
            console.log(erro);
        }
    }

    const handleChange = (e) => {

        const idBusca = parseInt(e.target.value, 10) || null; // Se for "" transforma em null
        const tipoRelatorioObj = tipoRelatorioList.find(
            (tr) => tr.id === idBusca
        );
        setTipoRelatorio(tipoRelatorioObj)
    };

    return (
        <div className=''>
            {tipoRelatorioList ? (
                <div className="d-flex flex-column flex-md-row gap-1 align-items-center">
                    <label htmlFor="status">Tipo de Relatório</label>
                    <select
                        className="form-control-sm mw-100"
                        name="status"
                        defaultValue=""
                        onChange={handleChange}
                    >
                        <option value={null}>Selecione uma opção</option>
                        {tipoRelatorioList.map((tipoRelatorio) => (
                            <option key={tipoRelatorio.codigo} value={tipoRelatorio.codigo}>
                                {tipoRelatorio.descricao}
                            </option>
                        ))}
                    </select>
                </div>
            ) : (
                <p>Carregando informações dos tipos de relatórios...</p>
            )}
        </div>
    )
}

export default SelectTipoRelatorio